<template lang="pug">
div
	button.btn.btn-primary(v-if="!addingEvent && !editingEvent" type="button" @click="addingEvent=true")
		|Añadir evento
	.card(v-if="addingEvent || editingEvent")
		.card-header
			h5(v-if="addingEvent") Añadir evento para el día {{ popoverDate }}
			h5(v-if="editingEvent") Editar el evento {{ event.title }}
		.card-body
			.form-group
				label(for="title") Título
				textarea.form-control(id="title" placeholder="Nombra el evento" rows="1" v-model="event.title" required)
			.form-group
				label(for="description") Descripción
				textarea.form-control(id="description" placeholder="Descripción" v-model="event.description" required)
			.form-inline
				.form-group
					label(for="startHour") Desde &nbsp;
					input.form-control(type="time" id="startHour" v-model="event.startHour" required) 
				span &nbsp;&nbsp;
				.form-group
					label(for="endHour") Hasta &nbsp;
					input.form-control(type="time" id="endHour" v-model="event.endHour" required)
			.form-group
				label(for="color") Elige el color
				select.form-control(id="color" v-model="event.color")
					option(v-for="color in colors" :key="color" :value="color" :style="{ backgroundColor: color }") {{ color }}
		.card-body.bg-light
			button.btn.btn-info(v-if="addingEvent" @click="addEvent" :disabled="!event.title || !event.description") Guardar
			button.btn.btn-info(v-if="editingEvent" @click="editEvent" :disabled="!event.title || !event.description") Guardar edición
			button.btn.btn-danger(@click="cancel") Cancelar
			br
	br
	TodayEvents(:popoverDate="popoverDate" ref="tEvents" @edit="editedEvent" @remove="removeEvent")
</template>

<script>
import axios from 'axios'
import TodayEvents from './today'
export default {
	props: {
		popoverDate: String
	},
	components: {
		TodayEvents
	},
	data () {
		return {
			event: {
				id: null,
				title: null,
				description: null,
				startHour: '09:00',
				endHour: '20:00',
				color: 'red',
				userID: null
			},
			mesAno: null,
			addingEvent: false,
			editingEvent: false,
			colors: ['blue', 'red', 'green']
		}
	},
	methods: {
		addEvent () {
			const fechastartHour = this.popoverDate + ' ' + this.event.startHour + ':00'
			const fechaendHour = this.popoverDate + ' ' + this.event.endHour + ':00'
			axios.get('muro/php/lib/eventos/addEvent.php?fechastartHour=' + fechastartHour + '&fechaendHour=' + fechaendHour + '&title=' + this.event.title + '&description=' + this.event.description + '&color=' + this.event.color)
				.then(res => {
					this.cancel()
					this.$emit('updateEvents')
					this.getDayEvents()
				})
				.catch(e => {
					this.$error(e)
				})
		},
		editEvent () {
			const fechastartHour = this.popoverDate + ' ' + this.event.startHour
			const fechaendHour = this.popoverDate + ' ' + this.event.endHour
			axios.get('muro/php/lib/eventos/editEvent.php?id=' + this.event.id + '&fechastartHour=' + fechastartHour + '&fechaendHour=' + fechaendHour + '&title=' + this.event.title + '&description=' + this.event.description + '&color=' + this.event.color + '&userID=' + this.event.userID)
				.then(res => {
					this.cancel()
					this.$emit('updateEvents')
					this.getDayEvents()
				})
				.catch(e => {
					this.$error(e)
				})
		},
		removeEvent (event) {
			axios.get('muro/php/lib/eventos/removeEvent.php?id=' + event.id + '&userID=' + event.userID)
				.then(res => {
					this.cancel()
					this.$emit('updateEvents')
					this.getDayEvents()
				})
				.catch(e => {
					console.log(e)
					this.$error(e)
				})
		},
		cancel () {
			this.event.id = null
			this.event.title = null
			this.event.description = null
			this.event.startHour = '09:00'
			this.event.endHour = '20:00'
			this.addingEvent = false
			this.editingEvent = false
		},
		editedEvent (event) {
			this.event = event
			this.editingEvent = true
			this.addingEvent = false
		},
		getDayEvents () {
			const child = this.$refs.tEvents
			child.getEvents()
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/calendario/addEvent.vue